import React, { useState, useMemo } from "react";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Line } from "react-chartjs-2";
import "../../../styles/superAdmin/usersChart.css";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
  Tooltip,
  Legend,
  Title
);

const monthLabels = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
];

const UsersChart = ({ usersStats }) => {

  // Prepare dynamic values from usersStats.monthly_users
  const values = useMemo(() => {
    const monthlyData = usersStats?.monthly_users || {};
    return Array.from({ length: 12 }, (_, i) => monthlyData[i + 1] || 0);
  }, [usersStats]);


  const data = {
    labels: monthLabels,
    datasets: [
      {
        label: "2025",
        data: values,
        fill: true,
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) return null;
          const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
          gradient.addColorStop(0, "rgba(0, 144, 255, 0.2)");
          gradient.addColorStop(1, "rgba(255,255,255,0)");
          return gradient;
        },
        borderColor: "#16166c",
        tension: 0,
        pointRadius: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
        align: "end",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          color: "#999",
          font: { size: 12 },
        },
      },
      title: {
        display: true,
        text: "Total Users",
        align: "start",
        color: "#16166c",
        font: { size: 14, weight: "bold" },
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          font: { size: 11 },
          color: "#888",
        },
      },
      y: {
        beginAtZero: true,
        grid: { color: "rgba(0,0,0,0.04)" },
        ticks: {
          font: { size: 11 },
          color: "#888",
          callback: (value) => (value >= 1000 ? value / 1000 + "k" : value),
        },
      },
    },
  };

  return (
    <div className="chart-card">
      <div className="chart-wrapper">
        <Line data={data} options={options} />
      </div>

    </div>
  );
};

export default UsersChart;
